module.exports = __webpack_public_path__ + "static/innovative-solutions-87f236895704d860aaf1bbe0bbbb6b45.jpg";